import s from './style.module.scss';
import { Display } from '@/components/Display/Display';
import CustomCursor from '@/components/Cursor';

const Mask = (props) => {
    return (
        <>
            <Display show={props.show}>
                <CustomCursor text={props?.text}></CustomCursor>
                <div className={s['mask']}>{props.children}</div>
            </Display>
        </>
    );
};
export default Mask;
